 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      style="margin: 0 auto; width: 100%; height: 100vh"
    >
      <div class="container123">
        <div class="titlemaun">
          <h4>审批配置</h4>
          <el-button type="primary" class="adduser" @click="add" style=" ;"
            >添加</el-button
          >
        </div>
      </div>
      <div class="info-content-container2">
        <div class="table_content1" style="width: 100%; margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            :header-cell-style="{ background: '#F4F5F7' }"
            class="data-table"
            v-loading="loading"
          >
            <el-table-column
              fixed
              prop="approveScene"
              align="center"
              label="审批场景"
              width
            >
              <template slot-scope="scope">
                <span>{{ scope.row.approveScene | approveScene }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="approveTemplateName"
              align="center"
              label="审批模板"
            >
            </el-table-column>

            <el-table-column fixed="right" align="center" label="操作" width>
              <template slot-scope="scope">
                <el-button
                  @click="approveSetEdit(scope.row.id, 'edit')"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="approveSetDel(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page">
            <!-- <p>
              共
              <span class="pagination-info-text">{{ Math.ceil(total/pagesize) }}</span>页
              <span>/</span>
              <span class="pagination-info-text">{{ total }}</span>条数据
            </p> -->
          </div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pagesize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <!-- 添加
        -->
        <el-dialog
          :title="dialogTitle"
          :visible.sync="centerDialogVisible"
          width="600px"
          center
          style="z-index: 10000"
        >
          <div class="info-content-container info-content-container-add">
            <el-form
              :inline="true"
              :model="dialogformInline"
              :rules="dialogRules"
              ref="refDialogformInline"
              class="demo-form-inline"
              style="margin-left: 70px"
            >
              <el-form-item label="审批场景：" prop="scene">
                <el-select
                  v-model="dialogformInline.scene"
                  class="el-dailog_width"
                  placeholder="请选择审批场景"
                >
                  <el-option
                    v-for="item in sceneListData"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="审批模板："
                prop="template"
                style="margin-top: 20px"
              >
                <el-select
                  v-model="dialogformInline.template"
                  class="el-dailog_width"
                  placeholder="请选择审批模板"
                >
                  <el-option
                    v-for="item in templateList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="："   class="scene" prop="">
            <el-select     >
             
            </el-select>
          </el-form-item> -->
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancellation">取 消</el-button>
            <el-button type="primary" @click="submitForm('refDialogformInline')"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <<script>
 export default {
     name:'approvalConfiguration',
     data() {
       return {
           dialogTitle:'',
           pagesize:10,
           currentPage:1,
           total:0,
           loading:false,//加载
           centerDialogVisible:false,//添加弹框
           genderList:[{
               value:'0',
               name:'男',
           },{
                value:'1',
               name:'女',
           }
           ],

      // formInline: {//查询条件（参数）
      //     user: '',
      //     role: '',
      //     nink:'',
      //     organization:''
      //   },
        dialogformInline:{//添加参数或者编辑参数
             scene:'',
             template:''
 
        },
         dialogRules: { // 弹框表单验证
        scene: [
          { required: true, message: "请选择审批场景",  trigger: "change" }
        ],
        template: [
          { required: true, message: "请选择审批模板", trigger: "blur" }
        ],      
      },
      sceneListData:[
          {
            label:'生长模型',
              id:0,
          },
          {
            label:'决策模型',
              id:1,
          },
      ],
      templateList:[
          {
          label:'生长模型生长模型',
            id:-1,
          },
          {
            label:'生长模型生长模型',
              id:0,
          },
          {
            label:'生长模型生长模型生长模型',
              id:1,
          },
      ],
      tableData: [],
      noneList:[{}],
      id:'',//
			remark:'',//备注
			updateId:'',//updateId
			updateTime:'',//创建修改时间,
      };     
    }, 
  created() {
     this.init()
  },
  methods:{
    init(){
        this.getApproveSet()//列表信息
    },
    handleCurrentChange(currentPage){//下一页
      this.currentPage=currentPage;
      this.getApproveSet()//查询列表
    },
    // 查询
    onSubmit(){
      this.getApproveSet()//查询列表
    },
    //查询审批配置
    getApproveSet(){
        this.$api.system
        .getApproveSet(
            this.currentPage,//第几页，默认1
            this.pagesize,//默认展示多少条，默认10
            )
        .then((res)=>{
            if(res.code==200){
                  console.log('')
                this.tableData=res.data;
            }else{
                this.$message.error(res.msg)
            }
        })
        .catch((err)=>{
            this.$message.error(err)
        })
      },
      //删除按钮
      approveSetDel(id){
        this.$confirm("是否删除？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
          })
        .then(() => {
           this.$api.system
            .delfun(`/pc/approveSet/delApproveSet`, id)
            .then((res) => {
              if (res.code == 200) {
                this.getApproveSet();//列表刷新
                this.$message({
                    type:'success',
                    message:res.msg
                })
             }else{
              this.$message.error(res.msg)
             }
            });
         
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
      },
      add(){//添加
          this.editId=''
          this.dialogTitle='添加审批配置'
          this.centerDialogVisible=true;
          this.getAllApproveTemplate()//查询全部审批模板
      },
      approveSetEdit(id ,type){
        if(type=='edit'){
          this.dialogTitle='编辑审批配置';
          this.centerDialogVisible=true;
          this.editId=id;//编辑id
          this.getapproveSetEdit()//编辑
          this.getAllApproveTemplate()//查询全部审批模板
        }
       },
      empty(){
          this.dialogformInline.scene='';//清空
          this.dialogformInline.template='';//清空
      },
      submitForm(formName) { // 提交表单
        this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.dialogTitle=='添加审批配置'){//为添加新用户
            this.saveApproveSet()// 新增
          }else{//为编辑
        this.saveApproveSet()
           }
 
        } else {
          return false;
        }
      });
    },
    //编辑时查询审批配置详情
    getapproveSetEdit(id){
      this.loading=true;//关闭加载
      this.$api.system
      .getapproveSetEdit(
            this.editId,//键id ，根据具体业务进行判定
            this.currentPage,//第几页，默认1
            this.pagesize,//默认展示多少条，默认10
          
      )
      .then((res)=>{
        if (res.code==200) {
            this.loading=false;//关闭加载
            this.dialogformInline.scene=res.data.approveScene;
            this.dialogformInline.template=res.data.approveTemplateId;
        }else{
          this.loading=false;//关闭加载
          this.$message.error(res.msg)
        }
      })
    },
    cancellation(){//弹框取消时
        this.empty();
        this.$forceUpdate()
        this.centerDialogVisible=false;
    },
    //添加用户是的接口
    saveApproveSet(){
      var formdata = {
        "approveScene":this.dialogformInline.scene,
        "approveTemplateId": this.dialogformInline.template, 
        "id":this.editId,
        "remark": this.remark, 
        "updateId": this.updateId,
        "updateTime":this.updateTime, 
      }
      this.loading=true;//开启加载
        this.$api.system
        .saveApproveSet(formdata).then((res)=>{
          this.loading=false;//关闭加载
          if (res.code==200) {
            this.centerDialogVisible=false;
            this.$message({type:'success',message:res.msg})
            this.getApproveSet()//列表信息
                      this.empty()  
            
          }else{

          }
        })
      },
    //新增环节
    addNode(){
        this.noneList.push('5')
    },
    // 查询全部审批模板
    getAllApproveTemplate(){
      this.$api.system
        .getAllApproveTemplate(
        )
        .then((res)=>{
          if (res.code==200) {
            this.templateList=res.data
          }else{
          }
        })
      },
    }
 };
 </script>
  <style lang="scss" scoped>
@import "../../style/approvalConfiguration.scss";
.scene {
  width: 280px;
}
.info-title1 {
  display: block;
}
li {
  padding-left: 15px;
}
</style>